import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import UploadPage from './components/UploadPage';
import PricesPage from './components/PricesPage';
import FAQPage from './components/FAQPage';
import ProductsPage from './components/ProductsPage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminPrices from './components/AdminPrices';
import AdminSettings from './components/AdminSettings';
import AdminDiscounts from './components/AdminDiscounts';
import AdminPromotion from './components/AdminPromotion';
import AdminPassword from './components/AdminPassword';
import AdminProducts from './components/AdminProducts';
import AdminPromoBanner from './components/AdminPromoBanner';
import AdminPromoCodes from './components/AdminPromoCodes';
import { Toaster } from './components/ui/toaster';
import GoogleAnalytics from './components/GoogleAnalytics';
import PromoPopup from './components/PromoPopup';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/logovanje" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <PromoPopup />
        <Routes>
          {/* Public Routes with Navbar */}
          <Route path="/" element={<><Navbar /><HomePage /></>} />
          <Route path="/upload" element={<><Navbar /><UploadPage /></>} />
          <Route path="/prices" element={<><Navbar /><PricesPage /></>} />
          <Route path="/proizvodi" element={<><Navbar /><ProductsPage /></>} />
          <Route path="/faq" element={<><Navbar /><FAQPage /></>} />
          
          {/* Admin Routes without Navbar */}
          <Route path="/logovanje" element={<AdminLogin />} />
          <Route 
            path="/logovanje/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/prices" 
            element={
              <ProtectedRoute>
                <AdminPrices />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/settings" 
            element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/discounts" 
            element={
              <ProtectedRoute>
                <AdminDiscounts />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/promotion" 
            element={
              <ProtectedRoute>
                <AdminPromotion />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/products" 
            element={
              <ProtectedRoute>
                <AdminProducts />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/password" 
            element={
              <ProtectedRoute>
                <AdminPassword />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/promo-banner" 
            element={
              <ProtectedRoute>
                <AdminPromoBanner />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/logovanje/promo-codes" 
            element={
              <ProtectedRoute>
                <AdminPromoCodes />
              </ProtectedRoute>
            } 
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;